import React from 'react';
import { useIncident } from '../context/incidentContext';
import CorrectiveActionWorkflow from '../../incident-log/components/CorrectiveActionWorkflow';

export default function IncidentRecordManagement() {
  const { selectedIncident, setSelectedIncident } = useIncident();
  return selectedIncident ? <CorrectiveActionWorkflow incident={selectedIncident} onClose={() => setSelectedIncident(null)} refreshList={false} /> : null;
}
